<style lang="scss" scoped>
.platform-page {
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);

  display: flex;

  &.page-lg {
    .container-navbar {
      height: calc(100% - 90px);
      overflow-y: auto;
      overflow-x: hidden;
    }
    .content {
      height: 100%;
      width: calc(100% - 300px);
      @media only screen and (min-width: 600px) and (max-width: 1025px) {
        width: 100%;
        overflow-x: hidden;
      }
    }
  }
  &.page-md {
    .content {
      height: 100%;
      width: 100%;
    }
  }
  &.page-sm {
    .container-navbar {
      height: calc(100% - 50px);
    }
    .content {
      height: 100%;
      width: 100%;
    }
  }
  .blur {
    filter: blur(3px);
  }
}
.trial-bar {
  height: 24px;
  width: 100%;
  background: var(--danger);

  & ~ .platform-page {
    height: calc(100vh - 24px);
    height: calc(var(--vh, 1vh) * 100 - 24px);
    @media only screen and (max-width: 576px) {
      overflow: scroll;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
::v-deep .tour-preview .content .footer .footer-link {
  color: var(--gray);
  &:hover {
    color: var(--dark);
  }
}

::v-deep .tour-preview {
  .scale,
  .close {
    padding: 5px;
    border-radius: 50%;
    margin-top: -5px;
    margin-right: -5px;
    path,
    use {
      fill: var(--white);
    }
    box-sizing: content-box;
    background-color: var(--gold);
  }
}
.small-medium {
  font-size: 80%;
  line-height: 1.5;
}

.select-plan .disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>

<style lang="scss">
.v--modal-overlay {
  height: calc(var(--vh, 1vh) * 100);
  z-index: 10000;
  .v--modal-box {
    @media only screen and (max-width: 767.98px) {
      overflow: auto;
    }
    .close {
      cursor: pointer;
      position: absolute;
      right: 16px;
      top: 16px;
      &:hover {
        opacity: 0.7;
      }
    }
  }
}
.tour-preview {
  .title {
    line-height: 27px !important;
  }
  &.is-scaled {
    .teaser {
      height: 40%;
    }
    .content {
      height: 60%;
    }
  }
  .description {
    overflow-y: auto;
    margin-bottom: 16px !important;
    ul {
      padding-left: 0;
    }
    li,
    ul li {
      list-style: none;
      position: relative;
      padding-left: 22px;
      margin-bottom: 4px;
    }
    li:after,
    ul li:after {
      content: '';
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: var(--gold);
      position: absolute;
      top: 10px;
      left: 0px;
    }
  }
}
.select-plan {
  display: flex;
  .plan-option {
    padding: 25px 15px;
    border: 1px solid var(--gray-light);
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
    transition: border-colror 0.15s ease-in-out;
    &.active,
    &:hover {
      border-color: var(--primary);
    }
  }
}
</style>

<template>
  <div>
    <modal
      name="purchase-plan"
      :pivotY="$root.sizer === 'lg' ? 0.5 : 0"
      :adaptive="$root.sizer === 'lg' ? false : true"
      :width="$root.sizer === 'lg' ? 800 : '100%'"
      :minHeight="600"
      :height="$root.sizer === 'lg' ? 'auto' : '100%'"
      :scrollable="true"
    >
      <div class="px-16 pt-16 pb-44 p-md-44">
        <div class="close" @click="$modal.hide('purchase-plan')">
          <i-cross class="i-14 fill-primary-dark"></i-cross>
        </div>
        <template v-if="currentUser.user.trial">
          <h4 class="fw-b text-primary-dark mb-8">{{ $t('pages.pricing.purchase_title') }}</h4>
          <p class="mb-32" v-html="$t('pages.pricing.purchase_desc')"></p>
        </template>
        <template v-else>
          <h4 class="fw-b text-primary-dark mb-8">{{ $t('pages.pricing.extend_title') }}</h4>
          <p class="mb-32" v-html="daysRemaining > 0 ? $t('pages.pricing.extend_ends_in_desc', { days: daysRemaining }) : $t('pages.pricing.extend_desc')"></p>
        </template>

        <el-error class="mb-16" :error="server_error"></el-error>
        <p class="mb-8 text-primary-dark">{{ $t('confirmation_modal.title') }}</p>
        <div class="select-plan row mb-16">
          <div class="col-6" :class="{ disabled: lockedPlan.includes('diy') }">
            <div class="plan-option d-flex flex-column" @click="selectedPlan = 'diy'" :class="{ active: selectedPlan === 'diy' }">
              <svg class="i-32 mb-16" width="10" height="15" viewBox="0 0 10 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.30074 5.86121C3.67017 5.86121 2.3487 4.54893 2.3487 2.9306C2.3487 1.31228 3.67017 0 5.30074 0C6.93131 0 8.25277 1.31228 8.25277 2.9306C8.25277 4.54893 6.93131 5.86121 5.30074 5.86121ZM6.5019 2.9306C6.5019 3.59009 5.96392 4.12433 5.30074 4.12433C4.63755 4.12433 4.09956 3.59009 4.09956 2.9306C4.09956 2.27112 4.63755 1.73688 5.30074 1.73688C5.96392 1.73688 6.5019 2.27112 6.5019 2.9306Z"
                  fill="#3F5B81"
                />
                <path
                  d="M0.0195217 11.1001C0.0195217 8.64613 2.02319 6.65639 4.4953 6.65639H5.52859C6.48105 6.65639 7.36397 6.95175 8.08955 7.45523C8.32028 7.61533 8.43042 7.89373 8.40816 8.17368V8.17368C8.3967 8.31783 8.34973 8.45689 8.27144 8.57846L8.25138 8.60962C8.09683 8.84962 7.82186 8.98401 7.53755 8.9585L7.48948 8.95419C7.26672 8.9342 7.0569 8.84775 6.86161 8.73873C6.46752 8.51873 6.01278 8.39326 5.52859 8.39326H4.4953C2.99058 8.39326 1.77039 9.60497 1.77039 11.1001C1.77039 11.1001 1.78553 12.3156 1.78553 13.3156C1.78553 14.3156 0.0346661 14.3156 0.0195217 13.3156C0.00437737 12.3156 0.0195217 11.1001 0.0195217 11.1001Z"
                  fill="#3F5B81"
                />
                <path
                  d="M8.57137 13.4707C7.88449 12.7845 7.03585 11.9643 7.03585 11.9643C7.03585 11.9643 6.21248 11.1188 5.52636 10.432C4.84025 9.74509 5.75394 8.8314 6.44018 9.51815C7.12642 10.2049 7.94929 11.0509 7.94929 11.0509C7.94929 11.0509 8.79844 11.8706 9.48519 12.5568C10.1719 13.2431 9.25825 14.1568 8.57137 13.4707Z"
                  fill="#3F5B81"
                />
                <path
                  d="M5.52946 12.5714C6.21558 11.8845 7.0358 11.0359 7.0358 11.0359C7.0358 11.0359 7.88128 10.2125 8.56815 9.52636C9.25503 8.84025 10.1687 9.75394 9.48197 10.4402C8.79522 11.1264 7.94923 11.9493 7.94923 11.9493C7.94923 11.9493 7.12952 12.7984 6.44328 13.4852C5.75704 14.1719 4.84335 13.2582 5.52946 12.5714Z"
                  fill="#3F5B81"
                />
              </svg>
              <div v-html="$t('confirmation_modal.diy')"></div>
            </div>
          </div>
          <div v-if="false" class="col-4" :class="{ disabled: lockedPlan.includes('no-followup') }">
            <div class="plan-option d-flex flex-column" @click="selectedPlan = 'no-followup'" :class="{ active: selectedPlan === 'no-followup' }">
              <svg class="i-32 mb-16" width="10" height="15" viewBox="0 0 10 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.30074 5.86121C3.67017 5.86121 2.3487 4.54893 2.3487 2.9306C2.3487 1.31228 3.67017 0 5.30074 0C6.93131 0 8.25277 1.31228 8.25277 2.9306C8.25277 4.54893 6.93131 5.86121 5.30074 5.86121ZM6.5019 2.9306C6.5019 3.59009 5.96392 4.12433 5.30074 4.12433C4.63755 4.12433 4.09956 3.59009 4.09956 2.9306C4.09956 2.27112 4.63755 1.73688 5.30074 1.73688C5.96392 1.73688 6.5019 2.27112 6.5019 2.9306Z"
                  fill="#3F5B81"
                />
                <path
                  d="M0.0195217 11.1001C0.0195217 8.64613 2.02319 6.65639 4.4953 6.65639H5.52859C6.48105 6.65639 7.36397 6.95175 8.08955 7.45523C8.32028 7.61533 8.43042 7.89373 8.40816 8.17368V8.17368C8.3967 8.31783 8.34973 8.45689 8.27144 8.57846L8.25138 8.60962C8.09683 8.84962 7.82186 8.98401 7.53755 8.9585L7.48948 8.95419C7.26672 8.9342 7.0569 8.84775 6.86161 8.73873C6.46752 8.51873 6.01278 8.39326 5.52859 8.39326H4.4953C2.99058 8.39326 1.77039 9.60497 1.77039 11.1001C1.77039 11.1001 1.78553 12.3156 1.78553 13.3156C1.78553 14.3156 0.0346661 14.3156 0.0195217 13.3156C0.00437737 12.3156 0.0195217 11.1001 0.0195217 11.1001Z"
                  fill="#3F5B81"
                />
                <path
                  d="M8.57137 13.4707C7.88449 12.7845 7.03585 11.9643 7.03585 11.9643C7.03585 11.9643 6.21248 11.1188 5.52636 10.432C4.84025 9.74509 5.75394 8.8314 6.44018 9.51815C7.12642 10.2049 7.94929 11.0509 7.94929 11.0509C7.94929 11.0509 8.79844 11.8706 9.48519 12.5568C10.1719 13.2431 9.25825 14.1568 8.57137 13.4707Z"
                  fill="#3F5B81"
                />
                <path
                  d="M5.52946 12.5714C6.21558 11.8845 7.0358 11.0359 7.0358 11.0359C7.0358 11.0359 7.88128 10.2125 8.56815 9.52636C9.25503 8.84025 10.1687 9.75394 9.48197 10.4402C8.79522 11.1264 7.94923 11.9493 7.94923 11.9493C7.94923 11.9493 7.12952 12.7984 6.44328 13.4852C5.75704 14.1719 4.84335 13.2582 5.52946 12.5714Z"
                  fill="#3F5B81"
                />
              </svg>
              <div v-html="$t('confirmation_modal.no_guidance')"></div>
            </div>
          </div>
          <div class="col-6" :class="{ disabled: lockedPlan.includes('followup') }">
            <div class="plan-option d-flex flex-column" @click="selectedPlan = 'followup'" :class="{ active: selectedPlan === 'followup' }">
              <svg class="i-32 mb-16" width="11" height="15" viewBox="0 0 11 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.27323 6.76111C4.64266 6.76111 3.32119 5.44883 3.32119 3.83051C3.32119 2.21218 4.64266 0.899902 6.27323 0.899902C7.9038 0.899902 9.22527 2.21218 9.22527 3.83051C9.22527 5.44883 7.9038 6.76111 6.27323 6.76111ZM7.4744 3.83051C7.4744 4.48999 6.93642 5.02423 6.27323 5.02423C5.61004 5.02423 5.07206 4.48999 5.07206 3.83051C5.07206 3.17102 5.61004 2.63678 6.27323 2.63678C6.93642 2.63678 7.4744 3.17102 7.4744 3.83051Z"
                  fill="#3F5B81"
                />
                <path
                  d="M0.992011 12C0.992011 9.54603 2.99569 7.55629 5.4678 7.55629H6.50108C8.97319 7.55629 10.9769 9.54603 10.9769 12C10.9769 12 10.999 13.2155 10.9995 14.2155C11 15.2155 9.24865 15.2155 9.24791 14.2155C9.24718 13.2155 9.226 12 9.226 12C9.226 10.5049 8.00581 9.29317 6.50108 9.29317H5.4678C3.96307 9.29317 2.74288 10.5049 2.74288 12C2.74288 12 2.75802 13.2155 2.75802 14.2155C2.75802 15.2155 1.00716 15.2155 0.992011 14.2155C0.976867 13.2155 0.992011 12 0.992011 12Z"
                  fill="#3F5B81"
                />
              </svg>
              <div v-html="$t('confirmation_modal.guidance')"></div>
            </div>
          </div>
        </div>
        <div class="bg-gray-light px-16 px-lg-32 py-24 d-flex flex-column mb-32">
          <div class="d-flex flew-row">
            <div class="text-primary-dark">
              <h4 v-if="currentUser.user.trial" class="mb-0 fw-b">
                {{ $t('pages.pricing.period') }}
              </h4>
              <h4 v-else class="mb-0 fw-b">{{ $t('pages.pricing.period_extend') }}</h4>
            </div>
            <h4 class="text-primary-dark ml-auto text-nowrap">€ {{ amount.toFixed(2) }}</h4>
          </div>
          <transition name="fade">
            <div v-if="confirmed_code" class="d-flex flew-row my-8">
              <span class="text-primary-dark">{{ $t('pages.pricing.discount') }}</span>
              <span class="text-primary-dark ml-auto">- € {{ discount_amount.toFixed(2) }}</span>
            </div>
          </transition>
          <transition name="fade">
            <div v-if="confirmed_code" class="d-flex flew-row">
              <hr class="w-100 border-primary my-8" />
            </div>
          </transition>
          <transition name="fade">
            <div v-if="confirmed_code" class="d-flex flew-row mt-8">
              <span class="text-primary-dark text-uppercase">{{ $t('pages.pricing.total') }}</span>
              <span class="text-primary-dark ml-auto">€ {{ discountedAmount.toFixed(2) }}</span>
            </div>
          </transition>
        </div>

        <template v-if="currentUser.user.trial">
          <p v-if="currentUser.user.profession_type_id !== 2" class="mb-8 d-flex small-sm">
            {{ $t('pages.pricing.purchase_item_1') }}
            <i-check class="i-14 bg-gold rounded-circle ml-auto my-auto" style="padding: 2px;"></i-check>
          </p>

          <p v-if="currentUser.user.profession_type_id !== 2" class="mb-8 d-flex small-sm">
            {{ $t('pages.pricing.purchase_item_2') }}
            <i-check class="i-14 bg-gold rounded-circle ml-auto my-auto" style="padding: 2px;"></i-check>
          </p>

          <p class="mb-8 d-flex small-sm">
            {{ $t('pages.pricing.purchase_item_3') }}
            <i-check class="i-14 bg-gold rounded-circle ml-auto my-auto" style="padding: 2px;"></i-check>
          </p>

          <p class="mb-8 d-flex small-sm" :class="{ 'mb-24': selectedPlan === 'diy' }">
            {{ $t('pages.pricing.purchase_item_4') }}
            <i-check class="i-14 bg-gold rounded-circle ml-auto my-auto" style="padding: 2px;"></i-check>
          </p>

          <p class="mb-24 d-flex small-sm" v-if="selectedPlan === 'no-followup'">
            {{ $t('pages.pricing.purchase_item_6') }}
            <i-check class="i-14 bg-gold rounded-circle ml-auto my-auto" style="padding: 2px;"></i-check>
          </p>

          <p class="mb-24 d-flex small-sm" v-if="selectedPlan === 'followup'">
            {{ $t('pages.pricing.purchase_item_5') }}
            <i-check class="i-14 bg-gold rounded-circle ml-auto my-auto" style="padding: 2px;"></i-check>
          </p>
        </template>
        <template v-else>
          <p v-if="currentUser.user.profession_type_id !== 2" class="mb-8 d-flex small-sm">
            {{ $t('pages.pricing.purchase_item_1_extend') }}
            <i-check class="i-14 bg-gold rounded-circle ml-auto my-auto" style="padding: 2px;"></i-check>
          </p>

          <p v-if="currentUser.user.profession_type_id !== 2" class="mb-8 d-flex small-sm">
            {{ $t('pages.pricing.purchase_item_2_extend') }}
            <i-check class="i-14 bg-gold rounded-circle ml-auto my-auto" style="padding: 2px;"></i-check>
          </p>

          <p class="mb-8 d-flex small-sm">
            {{ $t('pages.pricing.purchase_item_3_extend') }}
            <i-check class="i-14 bg-gold rounded-circle ml-auto my-auto" style="padding: 2px;"></i-check>
          </p>

          <p class="mb-8 d-flex small-sm" :class="{ 'mb-24': selectedPlan !== 'followup' }">
            {{ $t('pages.pricing.purchase_item_4_extend') }}
            <i-check class="i-14 bg-gold rounded-circle ml-auto my-auto" style="padding: 2px;"></i-check>
          </p>

          <p class="mb-24 d-flex small-sm" v-if="selectedPlan === 'followup'">
            {{ $t('pages.pricing.purchase_item_5_extend') }}
            <i-check class="i-14 bg-gold rounded-circle ml-auto my-auto" style="padding: 2px;"></i-check>
          </p>
          
        </template>

        <p-check v-model="aggreed_to_terms" class="p-curve p-svg p-jelly text-wrap" color="primary">
          <i-check slot="extra" class="svg svg-icon"></i-check>
          <span class="small-medium">
            <span class="fw-b">{{ currentUser.first_name }} {{ currentUser.last_name }}</span
            >, {{ $t('confirmation_modal.confirmation') }}
          </span>
        </p-check>
        <div class="d-block mb-60"></div>

        <div v-if="has_discount_code" class="d-flex flex-row mb-16">
          <input v-model="code" type="text" class="form-control" :placeholder="$t('pages.pricing.fill_in_code')" :class="{ 'mr-16': !pattern_required }" />
          <button v-if="!pattern_required" class="btn btn-outline-primary-dark d-flex align-items-center" @click="checkCode" v-bind:class="{ disabled: code_loading }">
            {{ $t('general.add') }}
            <template v-if="code_loading">
              <i-loader class="ml-2 i-20 my-auto fill-primary"></i-loader>
            </template>
            <template v-if="code_success">
              <i-check class="ml-2 i-20 my-auto fill-primary"></i-check>
            </template>
          </button>
        </div>
        <a v-else href="#" @click="has_discount_code = true" class="text-gray text-center mb-16 w-100 d-block">{{ $t('pages.pricing.i_have_a_discount_code') }}</a>
        <div v-if="pattern_required" class="d-flex flex-row mb-16">
          <input v-model="pattern_code" type="text" class="form-control mr-16" :placeholder="$t('pages.pricing.fill_in_pattern_code')" />
          <button class="btn btn-outline-primary-dark d-flex align-items-center" @click="checkCode" v-bind:class="{ disabled: code_loading }">
            {{ $t('general.add') }}
            <template v-if="code_loading">
              <i-loader class="ml-2 i-20 my-auto fill-primary"></i-loader>
            </template>
            <template v-if="code_success">
              <i-check class="ml-2 i-20 my-auto fill-primary"></i-check>
            </template>
          </button>
        </div>
        <div v-if="has_discount_code && code_server_error" class="d-flex flex-row mb-16">
          <el-error class="mb-16" :error="code_server_error"></el-error>
        </div>
        <button class="btn btn-primary-dark btn-block hover-gold mb-32 mb-md-0" @click="submitPayment" v-bind:class="{ disabled: loading || !canSubmitPlan }">
          <template v-if="currentUser.user.trial">
            {{ $t('pages.pricing.order') }}
          </template>
          <template v-else>
            {{ $t('pages.pricing.extend') }}
          </template>
          <template v-if="loading">
            <i-loader class="ml-2 i-20 my-auto"></i-loader>
          </template>
          <template v-if="success">
            <i-check class="ml-2 i-20 my-auto"></i-check>
          </template>
        </button>
      </div>
    </modal>

    <div v-if="currentUser.user.trial" class="trial-bar small text-white text-center d-flex">
      <span class="m-auto"
        >{{ $tc('trial.ends_in_days', 7 - currentUser.user.current_day > 0 ? 7 - currentUser.user.current_day : 0, { days: 7 - currentUser.user.current_day }) }}
        <a href="#" @click="$modal.show('purchase-plan')" class="fw-b text-white">{{ $t('trial.upgrade') }}</a></span
      >
    </div>

    <div class="platform-page can-tour-blur" :class="[`page-${$root.sizer}`]">
      <div class="content">
        <navbar></navbar>

        <router-view class="container-fluid container-navbar position-relative oy-sm-auto" :key="$route.query.date ? $route.path + '_' + $route.query.date : $route.path"></router-view>
      </div>

      <sidebar v-if="$root.sizer === 'lg'">
        <template v-if="$route.meta.profile_side">
          <div class="sidebar-line"></div>
          <router-link :to="{ name: 'user-settings' }" class="sidebar-item" active-class="active">
            {{ $t('sidebar.user-settings') }}
          </router-link>
          <router-link :to="{ name: 'user-habits' }" class="sidebar-item" active-class="active">
            {{ $t('sidebar.user-habits') }}
          </router-link>
          <router-link :to="{ name: 'user-medical' }" class="sidebar-item" active-class="active">
            {{ $t('sidebar.user-medical') }}
          </router-link>
          <router-link :to="{ name: 'user-license' }" class="sidebar-item" active-class="active">
            {{ $t('sidebar.user-license') }}
          </router-link>
          <router-link :to="{ name: 'user-password' }" class="sidebar-item" active-class="active">
            {{ $t('sidebar.user-password') }}
          </router-link>
          <router-link :to="{ name: 'logout' }" class="btn btn-outline-white mx-auto mt-48" active-class="active">
            {{ $t('sidebar.sign-off') }}
          </router-link>
        </template>
        <template v-else>
          <router-link class="text-white text-center small mb-48 mb-lg-16 mb-xl-48" :to="{ name: 'user-settings' }">{{ $t('sidebar.change-profile') }}</router-link>

          <template v-if="scheduleOverview">
            <a
              v-if="currentUser.user.profession_type_id !== 2"
              href="#"
              @click="goToCurrentWeek"
              class="text-white text-center mb-32"
              v-html="$t('sidebar.your-schedule', { week: currentUser.user.current_week })"
            ></a>
            <div v-if="currentUser.user.profession_type_id !== 2" class="mb-60 d-flex flex-wrap px-60 justify-content-between">
              <div class="d-flex flex-column">
                <i-to-bed class="i-42 mx-auto mb-16 fill-white"></i-to-bed>
                <template v-if="!currentUser.user.trial">
                  <p v-if="scheduleOverview.in_bed" class="text-white text-center">
                    {{ scheduleOverview.in_bed }}
                  </p>
                  <p v-else class="text-white text-center"></p>
                </template>
                <p v-else class="text-white text-center blur">23:00</p>
              </div>
              <div class="d-flex flex-column">
                <i-get-out class="i-42 mx-auto mb-16 fill-white"></i-get-out>
                <template v-if="!currentUser.user.trial">
                  <p v-if="scheduleOverview.awaken" class="text-white text-center">
                    {{ scheduleOverview.awaken }}
                  </p>
                  <p v-else class="text-white text-center"></p>
                </template>
                <p v-else class="text-white text-center blur">07:30</p>
              </div>

              <!-- not Trial -->
              <!-- not in week 0 or 1 -->
              <!-- current week does NOT equal recommended week -->
              <!-- no schedule found -->
              <!-- not shift worker -->
              <div
                v-if="
                  !currentUser.user.trial &&
                    currentUser.user.current_week !== 0 &&
                    currentUser.user.current_week !== currentUser.user.recommended_week &&
                    currentUser.user.current_week !== 1 &&
                    (!scheduleOverview.awaken && !scheduleOverview.in_bed) &&
                    currentUser.user.profession_type_id !== 2
                "
                class="w-100 text-white text-center small"
              >
                {{ $t('sidebar.no_schedule_past_week') }}
              </div>

              <!-- not Trial -->
              <!-- not in week 0 or 1 -->
              <!-- current week DOES equal recommended week -->
              <!-- no schedule found -->
              <!-- not shift worker -->
              <div
                v-if="
                  !currentUser.user.trial &&
                    currentUser.user.current_week !== 0 &&
                    currentUser.user.current_week === currentUser.user.recommended_week &&
                    currentUser.user.current_week !== 1 &&
                    (!scheduleOverview.awaken && !scheduleOverview.in_bed) &&
                    currentUser.user.profession_type_id !== 2
                "
                class="w-100 text-white text-center small"
              >
                {{ $t('sidebar.schedule_will_unlock_soon') }}
              </div>

              <!-- not Trial -->
              <!-- In week 1 -->
              <!-- no schedule found -->
              <div
                v-if="
                  !currentUser.user.trial &&
                    currentUser.user.current_week === 1 &&
                    currentUser.user.current_day === 7 &&
                    (!scheduleOverview.awaken && !scheduleOverview.in_bed) &&
                    currentUser.user.profession_type_id !== 2
                "
                class="w-100 text-white text-center small"
              >
                {{ $t('sidebar.schedule_will_unlock_tomorrow') }}
              </div>

              <div v-if="currentUser.user.current_day < 7 && currentUser.user.profession_type_id !== 2" class="w-100 text-white text-center small mt-16">
                {{ $t('sidebar.schedule_will_unlock_in', { days: 7 - currentUser.user.current_day }) }}
              </div>

              <a v-else-if="currentUser.user.trial && currentUser.user.profession_type_id !== 2" href="#" @click="$modal.show('purchase-plan')" class="w-100 text-white text-center small mt-16">
                {{ $t('sidebar.schedule_will_unlock_now') }}
              </a>
            </div>
          </template>
          <div v-if="currentUser.user.profession_type_id === 2" class="d-none d-lg-block mb-100"></div>

          <div class="chart-container" v-if="chartData">
            <p class="text-white text-center mb-16">{{ $t('sidebar.your-sleep-evolution') }}</p>
            <bar-chart :chart-data="chartData" :height="185"></bar-chart>
            <div class="chart-border-bottom"></div>
          </div>
        </template>
      </sidebar>
    </div>

    <template v-if="$root.sizer !== 'sm'">
      <tour :steps="tourSteps" :start-large="!showPayment" :text="text" :theme="tourTheme" ref="tour">
        <template v-if="currentUser.user.trial" slot="step-8">
          <div class="text-center mt-16">
            <a
              class="btn btn-primary hover-gold mx-8"
              href="#"
              @click="
                $refs.tour.close();
                $modal.show('purchase-plan');
              "
            >
              {{ $t('general.start_today') }}
            </a>
            <a class="btn btn-primary mx-8" href="#" @click="$refs.tour.close()">
              {{ $t('general.start_trial') }}
            </a>
          </div>
        </template>
      </tour>
    </template>
  </div>
</template>

<script>
import Tour from '@salamander.be/vue-tour';
import { sidebar, navbar } from '@/components/layouts/';
import '@salamander.be/vue-tour/dist/vue-tour.css';
import { BarChart } from '@/components/charts';
import { ElError, PCheck } from '@/components/forms';
import VueCookies from 'vue-cookies';

export default {
  name: 'page-platform-index',

  components: { Tour, BarChart, sidebar, navbar, ElError, PCheck },
  props: {
    showPayment: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      success: false,
      server_error: null,
      code_loading: false,
      code_success: false,
      code_server_error: null,
      discount_amount: null,
      code: null,
      confirmed_code: null,
      amount: 495.0,
      pattern_required: false,
      pattern_code: null,
      confirmed_pattern_code: null,
      selectedPlan: 'followup',
      availableRates: [],
      lockedPlan: [],

      tourSteps: [
        {
          preview: '/images/online-slaaptraining.png',
          title: this.$t('tour.step_1_title'),
          description: this.$t('tour.step_1_description'),
          next_cta: this.$t('tour.step_1_next_cta'),
        },
        {
          preview: '/images/sts-schedule-overview.gif',
          title: this.$t('tour.step_2_title'),
          description: this.$t('tour.step_2_description'),
        },
        {
          preview: '/images/sts-schedule-tip.gif',
          title: this.$t('tour.step_3_title'),
          description: this.$t('tour.step_3_description'),
        },
        {
          preview: '/images/jouw-evolutie.png',
          title: this.$t('tour.step_4_title'),
          description: this.$t('tour.step_4_description'),
        },
        {
          preview: '/images/cushion.png',
          title: this.$t('tour.step_5_title'),
          description: this.$t('tour.step_5_description'),
        },
        {
          preview: '/images/sts-schedule-personal-info.gif',
          title: this.$t('tour.step_6_title'),
          description: this.$t('tour.step_6_description'),
        },
        {
          preview: '/images/sts-schedule-create-flow.gif',
          title: this.$t('tour.step_7_title'),
          description: this.$t('tour.step_7_description'),
        },
        {
          preview: '/images/cushion.png',
          title: this.$t('tour.step_8_title'),
          description: this.$t('tour.step_8_description'),
        },
      ],
      tourTheme: {
        color: '#0f3261',
        radius: '2px',
      },
      text: {
        next_cta: this.$t('tour.next_cta'),
        prev_cta: this.$t('tour.prev_cta'),
        restart_cta: this.$t('tour.restart_cta'),
      },

      discount_code: null,
      has_discount_code: false,
      has_trial: true,
      aggreed_to_terms: false,
    };
  },
  mounted() {
    if (window.innerWidth >= 1024) this.sizer = 'lg';
    else if (window.innerWidth >= 576) this.sizer = 'md';
    else this.sizer = 'sm';

    let set_plan = VueCookies.get('set_plan');
    let set_plan_locked = VueCookies.get('set_plan_locked');

    if (set_plan && set_plan === 'basic') {
      this.selectedPlan = 'no-followup';
      if (set_plan_locked) {
        this.lockedPlan = ['followup', 'diy'];
      }
    }
    if (set_plan && set_plan === 'allin') {
      this.selectedPlan = 'followup';
      if (set_plan_locked) {
        this.lockedPlan = ['no-followup', 'diy'];
      }
    }
    if (set_plan && set_plan === 'diy') {
      this.selectedPlan = 'diy';
      if (set_plan_locked) {
        this.lockedPlan = ['followup', 'no-followup'];
      }
    }

    this.$store.dispatch('schedule/readScheduleOverview', {
      user_id: this.currentUser.user.id,
      force: false,
    });
    if (this.showPayment) {
      let query = Object.assign({}, this.$route.query);
      delete query.payment;
      this.$router.replace(query);
      this.$modal.show('purchase-plan');
    }

    if (!this.currentUser.user.trial) {
      if (this.selectedPlan === 'followup') this.amount = 110;
      else this.amount = 110;
    }
  },

  methods: {
    submitPayment() {
      this.loading = true;

      let paymentType = this.currentUser.user.trial ? 'payment_type.initial' : 'payment_type.upgrade';
      if (this.selectedPlan === 'no-followup') {
        paymentType += '_no_follow_up';
      }
      if (this.selectedPlan === 'diy') {
        paymentType += '_diy';
      }

      let data = {
        id: this.currentUser.user.id,
        paymentType: paymentType,
        code: this.confirmed_code,
        pattern_code: this.confirmed_pattern_code,
      };
      if (!this.currentUser.user.trial) data.weeks = 6;

      this.$store.dispatch('payments/create', data).then(
        data => {
          this.loading = false;
          this.success = true;
          this.$modal.hide('purchase-plan');
          window.location = data.redirect_url;
        },
        error => {
          this.loading = false;
          this.success = false;
          this.server_error = error;
        },
      );
    },
    checkCode() {
      this.code_loading = true;
      this.removeCode();
      this.$store
        .dispatch('user/readCode', {
          user_id: this.currentUser.user.id,
          code: this.code,
          rate: this.rate,
          pattern_code: this.pattern_code,
        })
        .then(
          data => {
            this.confirmed_code = data.code;
            this.availableRates = data.rates;
            this.discount_amount = data.amount > this.amount ? this.amount : data.amount;
            this.pattern_required = data.pattern !== null;
            if (this.pattern_required) {
              this.confirmed_pattern_code = this.pattern_code;
            }

            this.code_loading = false;
            this.code_success = true;
            this.code_server_error = null;
          },
          error => {
            this.code_loading = false;
            this.code_success = false;

            if (error !== 'discount_code.check_validity.pattern_code_required' || this.pattern_required) {
              this.code_server_error = error;
            }
            if (error === 'discount_code.check_validity.pattern_code_required') {
              this.pattern_required = true;
            }
          },
        );
    },
    removeCode() {
      this.confirmed_code = null;
      this.discount_amount = null;
      this.code_success = false;
    },
    goToCurrentWeek() {
      this.$store.dispatch('schedule/setWeek', this.currentUser.user.current_week);
    },
  },

  computed: {
    currentUser() {
      return this.$store.getters['user/currentUser'];
    },
    scheduleOverview() {
      return this.$store.getters['schedule/overview'];
    },
    discountedAmount() {
      return Math.round((this.amount - this.discount_amount) * 100) / 100;
    },
    canSubmitPlan() {
      return this.aggreed_to_terms;
    },
    chartData() {
      if (!this.scheduleOverview) {
        return null;
      }
      let se = this.scheduleOverview.sleep_efficiencies;

      if (se.length === 1) {
        se = [se[0], 0, 0, 0, 0, 0];
      }

      return {
        labels: Object.values(se).map(e => (e ? e + '%' : '0%')),
        datasets: [
          {
            backgroundColor: Object.values(se).map(e => (e && e >= 85 ? '#c0ae66' : 'rgba(255, 255, 255, 0.9)')),
            data: Object.values(se).map(e => (e ? e : 0)),
          },
          {
            backgroundColor: 'rgba(242, 242, 242, 0.1)',
            data: Object.values(se).map(e => (e ? 100 - e : 100)),
          },
        ],
      };
    },
    daysRemaining() {
      return this.currentUser.user.total_weeks * 7 - this.currentUser.user.current_day;
    },
    rate() {
      let rate = this.currentUser.user.trial ? 'rate.initial' : 'rate.upgrade';
      if (this.selectedPlan === 'no-followup') {
        rate += '_no_follow_up';
      }
      if (this.selectedPlan === 'diy') {
        rate += '_diy';
      }
      return rate;
    },
  },
  watch: {
    selectedPlan() {
      if (!this.currentUser.user.trial) {
            this.amount = 110;
      } else {
        if (this.selectedPlan === 'followup') this.amount = 495;
        else if (this.selectedPlan === 'diy') this.amount = 199;
        else this.amount = 245;
      }
      if (!this.availableRates.includes(this.rate)) {
        this.removeCode();
      }
    },
  },
};
</script>
